import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        nombre: '',
        id_tipo_equipo: '',
        tarifa_dia: '',
        valor: '',
        errores: [],
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { nombre, id_tipo_equipo, tarifa_dia, valor } = this.state;
        var errores = [];
        if (!nombre) { errores.push("error_nombre"); }
        if (!id_tipo_equipo) { errores.push("error_id_tipo_equipo"); }
        if (!tarifa_dia) { errores.push("error_tarifa_dia"); }
        if (!valor) { errores.push("error_valor"); }
        console.log(errores.length);
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            nombre: nombre,
            id_tipo_equipo: id_tipo_equipo,
            tarifa_dia: tarifa_dia,
            valor: valor
        }
        Swal.showLoading();
        authAxios.post("equipos/registrar", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Equipos!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterEquipos");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Equipos!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    render() {
        const { nombre, id_tipo_equipo, tarifa_dia, valor } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE EQUIPOS</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-6">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="nombre" id="nombre" value={nombre} placeholder="Nombre" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Equipo</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="id_tipo_equipo">Tipo</label>
                                                    <select name="id_tipo_equipo" id="id_tipo_equipo"
                                                        className={((this.verificarError("error_id_tipo_equipo")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Tipo</option>
                                                        <option value="1">Eléctrico (ELEC)</option>
                                                        <option value="2">Equipo (EQU)</option>
                                                        <option value="3">Seguridad (SEG)</option>
                                                        <option value="4">Transporte (TR)</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="tarifa_dia">Tarifa / Día</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_tarifa_dia")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="tarifa_dia" id="tarifa_dia" value={tarifa_dia} placeholder="Tarifa / Día" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite la Tarifa / Día</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor">Valor</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_valor")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="valor" id="valor" value={valor} placeholder="Valor" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Valor</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Equipo</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterEquipos"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;